/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox, CheckboxProps, Col, Row, Select } from 'antd';
import Search from 'antd/es/input/Search';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getDropdownOptions } from '../../../hooks/GetDropdownOptions';
import { SearchTypeMapping } from '../../../utils/option-list/helper';
import styles from './styles.module.scss';

const StyledSelect = styled(Select)`
  && {
    width: 100%;
  }
  .ant-select-selection-item {
    line-height: 37px !important;
  }
  .ant-select-selection-placeholder {
    line-height: 36px !important;
    color: #9e9e9e;
  }
  .ant-select-selector {
    height: 40px !important;
  }
  .ant-select-selection-item-remove {
    line-height: 17px;
  }
`;
const StyledCheckedbox = styled(Checkbox)`
  .ant-checkbox-inner {
    background-color: #fff;
    border: 1px solid #d9d9d9;
  }
  .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
    background-color: #4096ff;
    border-color: transparent;
  }
`;
const StyledMultipleSelect = styled(Select)`
  && {
    width: 100%;
  }
  .ant-select-selector {
    height: 40px !important;
  }
  .ant-select-selection-placeholder {
    line-height: 40px !important;
    color: #9e9e9e;
  }
  .ant-select-selection-item-remove {
    line-height: 17px;
  }
`;
const StyleSearch = styled(Search)`
  && {
    width: 100%;
  }
  .ant-input {
    height: 40px !important;
  }
  .ant-btn {
    background: #478bbc;
    height: 40px !important;
    border: none;
  }
`;
interface SkillSearchComponentProps {
  setUrl: any;
  setPage: any;
  searchCriteriaList: Array<{ label: string; value: string }>;
  baseUrl: string;
}

const SkillSearchComponent: React.FC<SkillSearchComponentProps> = ({
  setUrl,
  setPage,
  baseUrl,
  searchCriteriaList,
}: SkillSearchComponentProps) => {
  const [dropdownOption, setDropdownOption] = useState<{
    [index: string]: Array<{ value: string; label: string }>;
  }>({});
  const [OPTIONS, setOPTIONS] = useState<Array<any>>([]);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [searchQuery, setSearchQuery] = useState<string>();
  const [profileStatus, setProfileStatus] = useState(true);
  const filteredOptions = OPTIONS.filter((o) => !selectedItems.includes(o));
  console.log('selectedItems', searchQuery, selectedItems);

  const handleSearchByKeyWord = (value: any, event: any) => {
    setUrl(baseUrl + `?` + searchQuery + '=' + value);
    setPage(1);
    // setSelectedItems([]);
  };

  useEffect(() => {
    getDropdownOptions(searchCriteriaList, setDropdownOption);
  }, []);

  useEffect(() => {
    if (searchQuery && SearchTypeMapping[searchQuery] === 'dropdown') {
      setOPTIONS(dropdownOption[searchQuery]);
    }
  }, [searchQuery]);

  const handleQuery = (e: any) => {
    setSearchQuery(e);
    if (e === 'all') {
      setUrl(baseUrl);
    }

    setSelectedItems([]);
    setPage(1);
  };

  useEffect(() => {
    if (searchQuery && searchQuery === 'resource_engaged') {
      const profile_status = profileStatus ? 1 : 4;
      if (profileStatus) {
        if (selectedItems.length > 0) {
          setUrl(
            baseUrl +
              `?resource_engaged=${selectedItems[0]}&profile_status=${profile_status}`
          );
        }
      } else {
        if (selectedItems.length > 0) {
          setUrl(
            baseUrl +
              `?resource_engaged=${selectedItems[0]}&profile_status=${profile_status}`
          );
        }
      }
      setPage(1);
    } else {
      setUrl(
        baseUrl +
          `?` +
          selectedItems
            .map((item: any) => searchQuery + '=' + item + '&')
            .join('')
      );
      setPage(1);
    }
  }, [selectedItems, profileStatus]);

  const handleSelectedItems = (e: any) => {
    setSelectedItems(e);
    setPage(1);
  };

  const onCheckboxChange: CheckboxProps['onChange'] = () => {
    setProfileStatus(!profileStatus);
  };
  const resourceEngaged = searchQuery && searchQuery === 'resource_engaged';
  return (
    <>
      <Row style={{ marginLeft: 16 }} gutter={[16, 16]} align={'middle'}>
        <Col span={resourceEngaged ? 9 : 12}>
          <StyledSelect
            className={styles['ant-select']}
            onChange={handleQuery}
            options={searchCriteriaList}
            placeholder="Select filter"
            defaultValue={'all'}
            dropdownMatchSelectWidth={true}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            virtual={false}
          />
        </Col>
        <Col span={resourceEngaged ? 9 : 12}>
          {searchQuery && SearchTypeMapping[searchQuery] === 'dropdown' ? (
            <>
              <StyledMultipleSelect
                className={styles['search-box']}
                mode="multiple"
                placeholder={
                  'Search by ' +
                  searchCriteriaList.filter((item) => {
                    return item.value === searchQuery;
                  })[0]['label']
                }
                showSearch
                value={selectedItems}
                onChange={handleSelectedItems}
                optionFilterProp="label"
                maxTagCount={3}
                showArrow
                onClick={(e) => e?.stopPropagation()}
                dropdownMatchSelectWidth={true}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
              >
                {filteredOptions.map((item) =>
                  Object.entries(item).map(([name, id]) => (
                    <Select.Option key={name} value={id} label={name}>
                      {name}
                    </Select.Option>
                  ))
                )}
              </StyledMultipleSelect>
            </>
          ) : (
            <StyleSearch
              disabled={!searchQuery || searchQuery === 'all' ? true : false}
              enterButton={<img src="/search.png" />}
              className={styles['search-box']}
              onSearch={handleSearchByKeyWord}
              placeholder={
                searchQuery && searchQuery !== 'all'
                  ? 'Search by ' +
                    searchCriteriaList.filter((item) => {
                      return item.value === searchQuery;
                    })[0]['label']
                  : 'Select filter option first'
              }
            />
          )}
        </Col>
        {resourceEngaged && (
          <Col span={6}>
            <StyledCheckedbox
              onChange={onCheckboxChange}
              name="profile_status"
              checked={profileStatus}
            >
              Status(Active)
            </StyledCheckedbox>
          </Col>
        )}
      </Row>
    </>
  );
};

export default SkillSearchComponent;
